import video from "./videoSlice";
export default video;
